export const frontmatter = {
    "draft": false,
    "title": "Panel de analíticas",
    "sidebar_group": "referencia",
    "sidebar_label": "Panel de analíticas",
    "sidebar_order": 11
}

export const toc = []